<template>
  <!-- Sidebar Toggle -->
  <a href="javascript:void(0);" id="toggle_btn">
    <span class="toggle-bars">
      <span class="bar-icons"></span>
      <span class="bar-icons"></span>
      <span class="bar-icons"></span>
      <span class="bar-icons"></span>
    </span>
  </a>
  <!-- /Sidebar Toggle -->
</template>
